<div class="mi-applicant-details container" id="mi-applicant-details" tabindex="-1" miFocusOnTab>

  <div class="row justify-content-center">
    <div class=" col-12 mi-panel-wrraper standart">
      <div class="mc-my-3">
        <span class="mi-header">{{tabsText.applicantDetails}}</span>
      </div>
      <div class="mi-white-panel with-shadow">

        <div class="mi-back ">
          <i class="pi pi-fw pi-chevron-right"></i>
          <span (click)="back()" id="mi-applicant-details-back" tabindex="0" role="button"
            (keyup.enter)="back()">{{genericText?.back}}
          </span>
        </div>

        <div>

          <span class="d-none d-sm-block mc-mt-1">
            {{validationText?.remark}}
          </span>
          <div class="mc-border-bottom d-none d-sm-block mc-mt-3"></div>
          <div>
            <mi-applicant-details-fields [applicant]="applicant"></mi-applicant-details-fields>
          </div>
        </div>

      </div>
      <div class=" row justify-content-center    justify-content-md-start">
        <div class="col-md-3 col-12 blue-button mi-next" id="mi-applicant-details-next">
          <mc-button [label]="genericText?.next + ' >'" (click)="next()"></mc-button>
        </div>
      </div>
    </div>
  </div>



</div>